import ExperimentationGroupSettingsResource from "../../../../resources/expapiunified/ExperimentationGroupSettings.resource.js";
import { createUnifiedRestApi } from "../utils.js";
const builder = createUnifiedRestApi(
  ExperimentationGroupSettingsResource,
  "experimentation-group-settings",
  (state) => state.experimentationGroupSettings
);
const {
  actions: getSettingsForEgActions,
  selectAsyncRequest: selectGetSettingsForEgAsyncRequest,
  isOfType: isGetSettingsForEgAsync
} = builder.addGetAction("getSettingsForEgAsync", (inputPayload) => {
  const { workspaceId: wsid, eg } = ExperimentationGroupSettingsResource.getWorkspaceIdAndEgFromPath(
    inputPayload.workspaceId
  );
  return ExperimentationGroupSettingsResource.getSettingsForEgAsync(wsid, eg);
});
const getSettingsForEgAsync = (workspaceId, eg) => getSettingsForEgActions.load({
  workspaceId: ExperimentationGroupSettingsResource.getWorkspaceEgPath(workspaceId, eg),
  id: eg
  // This is the key in redux store
});
const {
  actions: updateSettingsForEgActions,
  selectAsyncRequest: selectUpdateSettingsForEgAsyncRequest,
  isOfType: isUpdateSettingsForEgAsync
} = builder.addCreateOrUpdateAction("updateSettingsForEgAsync", (inputPayload) => {
  const { workspaceId: wsid, eg } = ExperimentationGroupSettingsResource.getWorkspaceIdAndEgFromPath(
    inputPayload.workspaceId
  );
  return ExperimentationGroupSettingsResource.updateSettingsForEgAsync(wsid, eg, inputPayload.id);
});
const updateSettingsForEgAsync = (workspaceId, eg, settingsId) => updateSettingsForEgActions.load({
  workspaceId: ExperimentationGroupSettingsResource.getWorkspaceEgPath(workspaceId, eg),
  id: settingsId,
  entity: void 0
});
const {
  epic: experimentationGroupSettingsEpic,
  reducer: experimentationGroupSettingsReducer,
  actions: experimentationGroupSettingsActions,
  matchers: experimentationGroupSettingsMatchers,
  selectors,
  getDefaultReducerState: getDefaultExperimentationGroupSettingsReducerState
} = builder.create();
const {
  selectAll: selectAllExperimentationGroupSettings,
  selectById: selectExperimentationGroupSettingsById,
  selectGetAsyncRequest: selectGetExperimentationGroupSettingsAsyncRequest,
  selectCreateOrUpdateAsyncRequest: selectCreateOrUpdateExperimentationGroupSettingsAsyncRequest,
  selectDeleteAsyncRequest: selectDeleteExperimentationGroupSettingsAsyncRequest
} = selectors;
const {
  getAsync: getExperimentationGroupSettingsAsync,
  createOrUpdateAsync: createOrUpdateExperimentationGroupSettingsAsync,
  deleteAsync: deleteExperimentationGroupSettingsAsync,
  queryAsync: queryExperimentationGroupSettingsAsync
} = experimentationGroupSettingsActions;
export {
  createOrUpdateExperimentationGroupSettingsAsync,
  deleteExperimentationGroupSettingsAsync,
  experimentationGroupSettingsEpic,
  experimentationGroupSettingsMatchers,
  experimentationGroupSettingsReducer,
  getDefaultExperimentationGroupSettingsReducerState,
  getExperimentationGroupSettingsAsync,
  getSettingsForEgAsync,
  isGetSettingsForEgAsync,
  isUpdateSettingsForEgAsync,
  queryExperimentationGroupSettingsAsync,
  selectAllExperimentationGroupSettings,
  selectCreateOrUpdateExperimentationGroupSettingsAsyncRequest,
  selectDeleteExperimentationGroupSettingsAsyncRequest,
  selectExperimentationGroupSettingsById,
  selectGetExperimentationGroupSettingsAsyncRequest,
  selectGetSettingsForEgAsyncRequest,
  selectUpdateSettingsForEgAsyncRequest,
  updateSettingsForEgAsync
};
//# sourceMappingURL=experimentation-group-settings.js.map
